import {
  baseUniDriverFactory,
  getDataAttributeValue,
} from '../test-utils/utils/unidriver';

export const sidebarDividerNextDriverFactory = (base, body) => {
  return {
    ...baseUniDriverFactory(base, body),

    /**
     * Checks whether SidebarDivider is displayed in full width
     * @returns {Promise<boolean>}
     */
    isFullWidth: async () =>
      (await getDataAttributeValue(base, 'data-full-width')) === 'true',

    /**
     * Returns the divider skin
     * @returns {Promise<string>}
     */
    getSkin: async () => await getDataAttributeValue(base, 'data-skin'),
  };
};
